export const isAdmin = () => {
    var bodyAdmin = document.querySelectorAll("body.wp-admin");
    return bodyAdmin.length;
};

export const forAllCallback = (selector, callback) => {
    var els = document.querySelectorAll(selector);
    if (els.length) {
        Array.from(els).forEach((el) => {
            callback(el);
        });
    }
};

export const onAllClick = (selector, handler) => {
    forAllCallback(selector, (el) => {
        el.addEventListener("click", handler);
    });
};

export const getHeaderHeight = () => {
    try {
        const headers = document.querySelectorAll("header");
        let headerHeight = 0;
        headers.forEach((header) => {
            headerHeight += header.offsetHeight;
        });
        const wpMenuBar = document.getElementById("wpadminbar");
        const wpMenuBarHeight = wpMenuBar ? wpMenuBar.offsetHeight : 0;
        return headerHeight + wpMenuBarHeight;
    } catch (e) {}
    return 0;
};

export const scrollToElement = (target) => {
    try {
        const headerHeight = getHeaderHeight();
        const elementPosition = target.offsetTop;
        const offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    } catch (e) {}
};

export const acfOnRender = (callback, block) => {
    try {
        if (window.acf) {
            const type = typeof block !== "undefined" ? "/type=" + block : "";
            console.log("type", type);
            window.acf.addAction("render_block_preview" + type, callback);
        }
    } catch (e) {
        console.log("acfOnRender", e);
    }
};

export const throttle = (callback, limit) => {
    var wait = false; // Initially, we're not waiting
    return function () {
        // We return a throttled function
        if (!wait) {
            // If we're not waiting
            callback.call(); // Execute users function
            wait = true; // Prevent future invocations
            setTimeout(function () {
                // After a period of time
                wait = false; // And allow future invocations
            }, limit);
        }
    };
};

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export const debounce = (func, wait, immediate) => {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export const objToURIComponents = (obj) => {
    var out = [];

    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            out.push(key + "=" + encodeURIComponent(obj[key]));
        }
    }

    return out.join("&");
};

export const docReady = (fn) => {
    // see if DOM is already available
    if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
    ) {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
};
